export default __webpack_public_path__ + "static/media/1_8_hl.694d7845.png";